import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IMealPlanResponse} from '../../models/meal-plans';
import {OptionsMealPlanTableEmitEnum} from '../../enums/meal-plan';
import {IUser} from '../../models/auth';
import {StorageService} from '../../services/storage/storage.service';

@Component({
  selector: 'app-historial-meal-plan-table',
  templateUrl: './historial-meal-plan-table.component.html',
  styleUrls: ['./historial-meal-plan-table.component.scss']
})
export class HistorialMealPlanTableComponent implements OnInit {
  optionsMealPlanTableEmitEnum = OptionsMealPlanTableEmitEnum;
  @Input() mealPlans: IMealPlanResponse[] = [];
  @Input() maxVisibleRows = 5;
  @Output() optionMealPlan: EventEmitter<{ option: OptionsMealPlanTableEmitEnum, id: string }> =
    new EventEmitter<{ option: OptionsMealPlanTableEmitEnum, id: string }>();
  userLogged: IUser;
  @Input() userType: 'patient' | 'expert';

  constructor(
    private storageService: StorageService
  ) { }

  ngOnInit(): void {
    this.userLogged = this.storageService.getLocalItem<{ user: IUser, token: string }>('user')?.user;
  }

  onEmmitSelectOptionMealPlan(option: OptionsMealPlanTableEmitEnum, id: string): void {
    this.optionMealPlan.emit({ option, id });
  }
}
